import { useState } from 'react';
import Menu from './Menu';
import Content from './Content';
import DetailedProduct from '../model/DetailedProductModel';
import ExplicationsContent from './ExplicationsContent';
import UserModel from '../model/UserModel';
import Quartiles from '../model/Quartiles';
import DetailsContent from './DetailsContent';
import DetailedAnalysisContent from './DetailedAnalysisContent';

interface InformationsProps {
  product: DetailedProduct;
  quartiles: Quartiles;
  user: UserModel | undefined;
  isGlobal: boolean;
}

export default function Informations(props: InformationsProps) {
  const [active, setActive] = useState<string>('détails');

  const impacts_global = {
    ecs: props.product.impact_global_ecs,
    acd: props.product.impact_global_acd,
    bvi: props.product.impact_global_bvi,
    etf: props.product.impact_global_etf,
    htc: props.product.impact_global_htc,
    htn: props.product.impact_global_htn,
    ozd: props.product.impact_global_ozd,
    cch: props.product.impact_global_cch,
    fwe: props.product.impact_global_fwe,
    swe: props.product.impact_global_swe,
    tre: props.product.impact_global_tre,
    pco: props.product.impact_global_pco,
    pma: props.product.impact_global_pma,
    ior: props.product.impact_global_ior,
    //pef: props.product.impact_global_pef,
    fru: props.product.impact_global_fru,
    mru: props.product.impact_global_mru,
    ldu: props.product.impact_global_ldu,
    wtu: props.product.impact_global_wtu,
  };

  return (
    <div className="xl:col-span-1 xl:row-span-2 overflow-hidden">
      <div className="flex h-[10%]">
        <Menu active={active} setActive={setActive} name="détails" />
        <Menu active={active} setActive={setActive} name="analyse" />
        <Menu active={active} setActive={setActive} name="explications" />
      </div>
      <div className="bg-blackOverlay dark:bg-whiteOverlay rounded-b-xl h-[90%]">
        <Content active={active} name="détails">
          <DetailsContent
            user={props.user}
            id={props.product._id}
            name={props.product.name}
            id_product={props.product.id_product}
            site={props.product.site}
            reliability={props.product.reliability}
            color={props.product.color_family}
            category={props.product.sub_category}
            weight={props.product.weight}
            materials={props.product.materials}
            country_fabric={props.product.country_fabric}
            country_dyeing={props.product.country_dyeing}
            country_making={props.product.country_making}
            category_predicted={props.product.category_predicted}
            reliability_details={props.product.reliability_details}
            sizes={props.product.sizes}
            product={props.product}
          />
        </Content>
        <Content active={active} name="analyse">
          <DetailedAnalysisContent
            impact_transport={props.product.impact_transport}
            impact_lifecycle={props.product.impact_lifecycle}
            impacts_global={impacts_global}
          />
        </Content>
        <Content active={active} name="explications">
          <ExplicationsContent />
        </Content>
      </div>
    </div>
  );
}
